export default __webpack_public_path__ + "static/media/unsplash.c376a746.svg";